import React from 'react';
import HODWaiverLimit from './HODWaiverLimit';
import '../../../CommonCSS/SocietyCSS.css'

const FeeWaiverAllocationApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Assign HOD Fee Waiver Limit</h5>
          </div>  
        </div>
        <HODWaiverLimit/>
      </div>
    </div >
  );
};

export default FeeWaiverAllocationApp;
